module.exports = __webpack_public_path__ + "img/A1-2-plan.6e7706a3.png";